import React, { createContext, useContext } from 'react'

import {
  getAnalyticsEventTrackingHandler,
  ANALYTICS_EVENTS
} from './utils'

// Create a context for analytics usage in the app
export const AnalyticsContext = createContext()

// Custom hook to consume analytics context easily
export const useAmplitudeAnalytics = () => useContext(AnalyticsContext)

const AmplitudeAnalyticsProvider = ({ user, config, children }) => {
  const analyticsValues = getAnalyticsEventTrackingHandler(config, user)

  return (
    <AnalyticsContext.Provider value={analyticsValues}>
      {children}
    </AnalyticsContext.Provider>
  )
}

export default AmplitudeAnalyticsProvider

// exported separately to allow usage in class components (hooks not supported)
export {
  ANALYTICS_EVENTS,
  getAnalyticsEventTrackingHandler
}
